module.exports = __webpack_public_path__ + "img/paypal_2024_10_23.9addefd.svg";